import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { ChangeDeliverCase, ChangePaidCase, getOrderDetails } from '../../redux/Slices/OrderSlice'
import notify from "./../UseNotification"

const UseAdminGetOrderDetails = () => {

    const { id } = useParams()
    const dispatch = useDispatch()
    const [loading, setLoading] = useState(true)
    const [paidloading, setPaidLoading] = useState(true)
    const [deliverloading, setdeliverLoading] = useState(true)
    const [deliverDisabledStatus, setdeliverDisabledStatus] = useState()
    const [paidDisabledStatus, setDisabledPaidStatus] = useState()
    const [payStatus, setPayStatus] = useState()
    const [deliverStatus, setDeliverStatus] = useState()
    const { orderDetails, PayCase, DeliverCase } = useSelector(state => state.OrderReducer)

    // to dispatch the get order details
    const OrderDetails = async () => {
        setLoading(true)
        await dispatch(getOrderDetails(id))
        setLoading(false)
    }

    // to run OrderDetails func when page is render
    useEffect(() => {
        OrderDetails()
    }, [])

    // to handle request response
    useEffect(() => {
        if (loading === false) {
            if (orderDetails.status === 200) {
                return;
            } else {
                notify("Error in Data, Please Try again", "error")
            }
        }
    }, [loading])

    // onChange paid case
    const handleChangePaidCase = (e) => {
        setPayStatus(e.target.value)
    }
    // handle dispatch pay status request
    const changePayRequest = async () => {
        if (payStatus === "0") {
            notify("please choose Paid status")
        }
        else if (payStatus === "true") {
            setPaidLoading(true)
            await dispatch(ChangePaidCase(id))
            setPaidLoading(false)
        } else if (payStatus === "false") {
        }
    }

    // to handle change paid response 
    useEffect(() => {
        if (paidloading === false) {
            if (PayCase.status === 200) {
                window.location.reload(false)
                setDisabledPaidStatus(true)
            }
        }
    }, [paidloading])

    // handle deliver change value
    const handleChangeDeliverCase = (e) => {
        setDeliverStatus(e.target.value)
    }

    // change the deliver case request
    const changeDeliverRequest = async () => {
        if (deliverStatus === "0") {
            notify("please choose deliver case", "error")
            return;
        }
        else if (deliverStatus === "true") {
            setdeliverLoading(true)
            await dispatch(ChangeDeliverCase(id))
            setdeliverLoading(false)
        }

    }

    // handle deliver request case
    useEffect(() => {
        if (deliverloading === false) {
            if (DeliverCase.status === 200) {
                window.location.reload("false")
                setdeliverDisabledStatus(true)
            }
        }
    }, [deliverloading])


    return [orderDetails, handleChangePaidCase, changePayRequest, handleChangeDeliverCase, changeDeliverRequest, deliverDisabledStatus, paidDisabledStatus]
}

export default UseAdminGetOrderDetails
